import * as types from '../types';

export const empty: types.InstitutionFilter = {
  text: '',
  tag: 'unit'
};
